import classNames from 'classnames';
import ToggleBox from 'components/toggle-box';
import { stopFactorStatusTranscript } from 'utils/prettier-status';
import { useClientContext } from '..';
import styles from '../application-group.module.scss';

const LegalCase = () => {
	const { application, legalCase, setLegalCase } = useClientContext();

	return (
		<>
			{application.legal_case_log ? (
				<div className={styles.legal_case_result}>
					<div className={styles.row}>
						<div className={styles.col}>Client Risky legal case</div>
						<div className={styles.col}>
							{application.legal_case_log.legal_case_has_correct_type ?? 'N/A'}
						</div>
						<div
							className={classNames(
								styles.col,
								(application.legal_case_log.is_approved === null ||
									application.legal_case_log.is_approved === 'approved') &&
									styles.green,
								application.legal_case_log.is_approved === 'rejected' && styles.red,
								application.legal_case_log.is_approved === 'review' && styles.yellow,
							)}
						>
							{stopFactorStatusTranscript(application.legal_case_log.is_approved)}
						</div>
					</div>
				</div>
			) : (
				<div className={styles.legal_case_input}>
					<label className={styles.toggle_box}>
						<ToggleBox
							active={legalCase.hasLegalCase}
							onToggle={() =>
								setLegalCase({
									...legalCase,
									hasLegalCase: !legalCase.hasLegalCase,
									legal_case_has_correct_type: legalCase.hasLegalCase
										? null
										: legalCase.legal_case_has_correct_type,
								})
							}
						/>
						Client has legal case
					</label>
					{legalCase.hasLegalCase && (
						<>
							<div className={styles.legal_case_title}>
								Is the legal case one of the following types:
							</div>
							<div className={styles.legal_case_list}>
								<div className={styles.legal_case_variant}>Financial issue</div>
								<div className={styles.legal_case_variant}>Bad credit reputation</div>
								<div className={styles.legal_case_variant}>Development and Operation Warning</div>
								<div className={styles.legal_case_variant}>Removal of commons</div>
								<div className={styles.legal_case_variant}>Public auction</div>
							</div>
							<div className={styles.legal_case_selection}>
								<label className={styles.legal_case_radio}>
									<input
										type="radio"
										name="legal_case_type"
										value="Yes"
										checked={legalCase.legal_case_has_correct_type === 'Yes'}
										onChange={(e) =>
											setLegalCase({
												...legalCase,
												legal_case_has_correct_type: e.target.value as 'Yes',
											})
										}
									/>
									Yes
								</label>
								<label className={styles.legal_case_radio}>
									<input
										type="radio"
										name="legal_case_type"
										value="No"
										checked={legalCase.legal_case_has_correct_type === 'No'}
										onChange={(e) =>
											setLegalCase({
												...legalCase,
												legal_case_has_correct_type: e.target.value as 'No',
											})
										}
									/>
									No
								</label>
							</div>
						</>
					)}
				</div>
			)}
		</>
	);
};

export default LegalCase;
